import {useTranslation} from "ni18n";
import React from "react";
import {v5Pages} from "src/components/_common/_constants";
import {useV5ImgSrc} from "src/useV5ImgSrc";

import {Btn} from "../V5Comp";
import styles from "./Resources.module.scss";

const Resources = () => {
  const i18n = useTranslation();

  const style = {
    backgroundImage: `url(${useV5ImgSrc("covid-positive-care-resources")})`,
  };

  return (
    <div className={`ph10 ${styles.outer}`} style={style}>
      <div className={`maxw90 ma df fdc aic-sm ${styles.inner}`}>
        <span className={styles.header}>{i18n.t("RESOURCES")}</span>
        <h2 className={styles.title}>{i18n.t("You may be isolated, but you're not alone.")}</h2>
        <p className={`maxw32 ${styles.text}`}>
          {i18n.t(
            "We've curated the best resources on the web to help you navigate life with and after testing positive for COVID-19.",
          )}
        </p>
        <Btn className="event-SKi37d" href={v5Pages.covidPositiveCare}>
          {i18n.t("Learn more")}
        </Btn>
      </div>
    </div>
  );
};

export default React.memo(Resources);
